import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getWindowDimensions } from '../Utils/Helpers';

const planTitleContainerStyleIos = getWindowDimensions.height < 800 ? 12 : 25;

export default StyleSheet.create({
  containerStyle: withTray => ({
    paddingBottom: withTray ? 130 : 80,
  }),
  errorIconStyle: {
    marginTop: 120,
  },
  planContainerStyle: {
    marginTop: 16,
  },
  titleContainerStyle: {
    marginTop: 10,
  },
  plansContainerStyle: {
    ...Platform.select({
      android: {
        marginTop: -10,
      },
    }),
  },
  planTitleContainerStyle: {
    paddingHorizontal: 15,
    marginTop: Platform.OS === 'ios' ? planTitleContainerStyleIos : 25,
    marginBottom: -13,
  },
  planTitleTextStyle: {
    fontSize: 25,
    ...Fonts.type.bold,
  },
  usageValuesTextStyle: {
    color: Colors.dark_grey,
  },
  errorTitleContainerStyle: {
    paddingHorizontal: 15,
    marginTop: Platform.OS === 'android' ? 16 : 25,
  },
});
